import { Tag as TagComponent } from '../../../atoms/tag/tag';
import { TagStyleVariants } from '../../../ui';

type TagProps = {
  label: string;
  tooltip?: string;
  variant: TagStyleVariants['variant'];
};

export function Tag(props: TagProps) {
  const { label, variant, tooltip } = props;

  return <TagComponent label={label} variant={variant} tooltip={tooltip} />;
}
